import AUApi from './api';
import { Capacitor } from "@capacitor/core";
import { FileHelperPlugin } from './FileHelper';



export function showPDF(pdfFile: string) {
    const url = AUApi.Current.fullUrl("pdf3/" + pdfFile, "", false);
    if (Capacitor.getPlatform() !== "android") {
        const res = window.open(url);
    } else {
        return FileHelperPlugin.downloadAndOpenFile({
            url,
            filename: "report.pdf",
            mimeType: "application/pdf"
        });
    }
}
export function showPDF2(pdfFile: string, pdfAic: string, user: string) {
    const url = AUApi.Current.fullUrl("pdf2/" + user + ":" + +pdfAic + "_" + pdfFile
    );
    if (Capacitor.getPlatform() !== "android") {
        const res = window.open(url);
    } else {
        return FileHelperPlugin.downloadAndOpenFile({
            url,
            filename: "report.pdf",
            mimeType: "application/pdf"
        });
    }
}

export function openFile(path:string, mimeType:string = "application/pdf") {
    FileHelperPlugin.openFile(path, mimeType);
}

export function showImage(image: any, pdfAic: string, user: string, mimeType: string = "application/pdf") {
    let url = AUApi.Current.fullUrl("pdf2/" + user + ":" + +pdfAic + "_" + image.name);
    if (image.datentyp !== "Doku") {
        url = AUApi.Current.fullUrl("image2/" + user + ":" + +pdfAic + "_" + image.name);
    }
    if (Capacitor.getPlatform() !== "android") {
        const res = window.open(url);
    } else {
        return FileHelperPlugin.downloadAndOpenFile({
            url,
            filename: "report.pdf",
            mimeType: mimeType
        });
    }
}
